import React from "react";
import { useNonNullableContext } from "../utils/nonNullableContext";

const IframeContext = React.createContext<{
  isIframe: boolean;
}>({ isIframe: false });

export const useIframe = () => useNonNullableContext(IframeContext, "Iframe");

export const IframeProvider = ({ children }: { children: React.ReactNode }) => {
  const isIframe = window.self !== window.top;
  return (
    <IframeContext.Provider value={{ isIframe }}>
      {children}
    </IframeContext.Provider>
  );
};
